// extracted by mini-css-extract-plugin
module.exports = {"textArea":"text_area_textArea__2OnQA"};